// extracted by mini-css-extract-plugin
export default {"receiptImage":"styles_receiptImage__prHcn"};